export const common = {
  locale: {
    dateTime: "pl-Pl",
  },
};

// route must not end in "/"
export const appRoutes = {
  api: {
    locations: {
      paginate: (): string => "/api/locations/paginate",
      index: (): string => "/api/locations",
      update: (id: number): string => "/api/locations/" + id,
      destroy: (id: number): string => "/api/locations/" + id,
    },
    users: {
      paginate: (): string => "/api/users/paginate",
      index: (): string => "/api/users",
      update: (id: number): string => "/api/users/" + id,
      usersInUserLocation: (id: number): string =>
        "/api/users/get-users-in-user-location/" + id,
      destroy: (id: number): string => "/api/users/" + id,
      allow: (id: number): string => "/api/users/allow/" + id,
      deny: (id: number): string => "/api/users/deny/" + id,
    },
    templates: {
      paginate: (): string => "/api/templates/paginate",
      view: (id: number): string => "/api/templates/" + id,
      create: (): string => "/api/templates",
      update: (id: number): string => "/api/templates/" + id,
      clone: (id: number): string => "/api/templates/clone/" + id,
      destroy: (id: number): string => "/api/templates/" + id,
      templateTags: (): string => "/api/template-tags",
    },
    inspections: {
      paginate: (): string => "/api/inspections/paginate",
      create: (): string => "/api/inspections",
      update: (id: number): string => "/api/inspections/" + id,
      destroy: (id: number): string => "/api/inspections/" + id,
      view: (id: number): string => "/api/inspections/" + id,
      cancel: (id: number): string => "/api/inspections/cancel/" + id,
      execute: (id: number): string => "/api/inspections/execute/" + id,
      settings: (): string => "/api/inspection-settings",
    },
    organisations: {
      paginate: (): string => "/api/organisations/paginate",
      index: (): string => "/api/organisations",
      update: (id: number): string => "/api/organisations/" + id,
      delete: (id: number): string => "/api/organisations/" + id,
      join: (id: number): string => "/api/organisations/join/" + id,
    },
    orgRequests: {
      paginate: (): string => "/api/org-requests/paginate",
    },
    reports: {
      paginate: (): string => "/api/reports/paginate",
      view: (id: number): string => "/api/reports/" + id,
      pdf: (uuid: string): string => "/api/reports/pdf/" + uuid,
      send: (id: number): string => "/api/reports/send/" + id,
    },
    incidents: {
      paginate: (): string => "/api/incidents/paginate",
      solve: (id: number): string => "/api/incidents/solve/" + id,
      count: (): string => "api/incidents/count",
      getIncidentTypes: (): string => "/api/incident-types",
      getIncidentTypesForFilter: (): string => "/api/incident-types/with-trashed",
      addIncident: (): string => "/api/incidents",
      addIncidentTypeReport: (): string => "/api/incident/create-from-qr-form",
      createIncidentType: (): string => "/api/incident-types/",
      updateIncidentType: (id: number): string => "/api/incident-types/" + id,
      deleteIncidentType: (id: number): string => "/api/incident-types/" + id,
    },
    logs: {
      paginate: (): string => "/api/logs/paginate",
    },
    languages: {
      index: (): string => "/api/languages",
      available: (): string => "/api/languages/available",
      destroy: (id: number): string => "/api/languages/" + id,
      view: (id: number): string => "/api/languages/" + id,
      default: (): string => "/api/languages/default",
      translations: (languageCode: string | number): string =>
        "/api/languages/" + languageCode + "/frontend-translations",
      updateWords: (): string => "/api/languages/translations",

      count: (): string => "/api/admin/languages/count",
      supportedLanguages: (): string =>
        "/api/admin/languages/supportedLanguages",
      update: (id: number): string => "/api/admin/languages/" + id,

      select: (): string => "/api/admin/languages/for-select",
    },
    billing: {
      subscription: () => "/api/stripe/subscriptions",
      customer: () => "/api/stripe/customer",
      paymentMethod: () => "/api/stripe/payment-method",
      address: () => "/api/stripe/address",
      invoices: () => "/api/stripe/invoices/paginate",
      enterprise: () => "/api/stripe/enterprise-request",
      products: () => "/api/stripe/products",
      taxTypes: () => "/api/stripe/tax-types",
      countries: () => "/api/stripe/countries",
      intent: () => "/api/stripe/setup-intent",
      key: () => "/api/stripe/public-key",
    },
    profile: {
      update: (): string => "/api/profile",
      password: (): string => "/api/profile/password",
      settings: (): string => "/api/profile/settings",
    },
    statistics: {
      short: (): string => "api/statistics/short",
      default: (): string => "api/statistics/counters/default",
    },
  },
};
